// Initialize Alpine.js

import Alpine from 'alpinejs'

import hash from './plugin.hash.js'
Alpine.plugin(hash)

import breakpoints from './plugin.breakpoints.js'
Alpine.plugin(breakpoints)

import focus from '@alpinejs/focus'
Alpine.plugin(focus)

import './data.transition.js'
import './data.popup.js'

window.Alpine = Alpine
